import Main from './Main';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Politicas from './components/Politicas/Politicas';
import TerminosCondiciones from './components/TerminosCondiciones/TerminosCondiciones';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Main />,
    exact: true,
  },
  {
    path: '/politica-privacidad',
    element: <Politicas />,
    exact: true,
  },
  {
    path: '/terminos-condiciones',
    element: <TerminosCondiciones />,
    exact: true,
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RouterProvider router={router} />
);
